import { LinkContent } from "../../LinkDataInterface";
import {
  faBook,
  faCodeBranch,
  faInbox,
  faMap,
  faUsersRectangle,
  faBuildingColumns,
  faIdBadge,
  faUserCheck,
  faCalculator,
  faPercent,
  faCreditCard,
  faBasketShopping,
  faCartShopping,
  faKey,
  faList,
  faFileContract,
  faCircleInfo,
  faYen,
  faPiggyBank,
} from "@fortawesome/free-solid-svg-icons";

/**** Outils ****/

// Externes
export const mail: LinkContent = {
  faLogo: faInbox,
  title: "Mail",
  link: "https://mail.google.com/mail/u/0/#inbox",
};
export const github: LinkContent = {
  faLogo: faCodeBranch,
  title: "GitHub",
  link: "https://github.com/Polyjapan",
};

// Internes
export const cartographe: LinkContent = {
  faLogo: faMap,
  title: "Cartographe",
  link: "https://cartographe.japan-impact.ch/",
};
export const wiki: LinkContent = {
  faLogo: faBook,
  title: "Wiki",
  link: "https://wiki.japan-impact.ch/",
};
export const accreds: LinkContent = {
  faLogo: faIdBadge,
  title: "Accreds",
  link: "https://accreds.japan-impact.ch/",
};
export const standsValidator: LinkContent = {
  faLogo: faUserCheck,
  title: "Validateur stand",
  link: "https://herminesnow.ch",
};
export const boutique: LinkContent = {
  faLogo: faBasketShopping,
  title: "JI Shop",
  link: "https://shop.japan-impact.ch/admin/",
};
export const espaceStaff: LinkContent = {
  faLogo: faUsersRectangle,
  title: "Espace Staff",
  link: "https://staff.japan-impact.ch/",
};
export const vault: LinkContent = {
  faLogo: faKey,
  title: "Vault (MdP)",
  link: "https://vault.japan-impact.ch/#/vault",
};
export const contractor: LinkContent = {
  faLogo: faFileContract,
  title: "Contractor",
  link: "https://contractor.japan-impact.ch/",
};
export const formulaireAnim: LinkContent = {
  faLogo: faList,
  title: "Formulaire animation",
  link: "https://forms.japan-impact.ch/",
};

export const xpense: LinkContent = {
  faLogo: faPiggyBank,
  title: "xpense",
  link: "https://xpense.japan-impact.ch",
};

/**** Présidence ****/
// Finances
export const bexio: LinkContent = {
  faLogo: faCalculator,
  title: "Bexio",
  link: "https://office.bexio.com/index.php/user/dashboard",
};
export const ubs: LinkContent = {
  faLogo: faBuildingColumns,
  title: "UBS Banque",
  link: "https://ebanking-ch4.ubs.com/workbench/WorkbenchOpenAction.do?login&locale=fr-CH&dnc=5514476",
};
export const tva: LinkContent = {
  faLogo: faPercent,
  title: "Déclaration TVA",
  link: "https://myestv.estv.admin.ch/",
};
export const carteDeCredit: LinkContent = {
  faLogo: faCreditCard,
  title: "amnis (Carte de crédit)",
  link: "https://app.amnistreasury.com/dashboard",
};
export const twint: LinkContent = {
  faLogo: faYen,
  title: "TWINT",
  link: "https://portal.twint.ch/partner/gui/dashboard",
};
export const paiementEnLigne: LinkContent = {
  faLogo: faCartShopping,
  title: "Paiement en ligne",
  link: "https://app-wallee.com/s/87433/space/dashboard",
};

// Général
export const coordonnesPJ: LinkContent = {
  faLogo: faCircleInfo,
  title: "Coordonnées PolyJapan",
  link: "https://docs.google.com/document/d/1adYh1AF4BPlsF5gBn3rh1OizT9_PbuiuxHLTdHaSQFs/",
};
